
import { useState, useEffect } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { AssessmentQuestion } from '@/types/assessment';

interface QuestionCardProps {
  question: AssessmentQuestion;
  selectedAnswer: string | undefined;
  onSelectOption: (option: string) => void;
  isVisible: boolean;
  direction: 'next' | 'prev';
}

const QuestionCard = ({ 
  question, 
  selectedAnswer, 
  onSelectOption, 
  isVisible, 
  direction 
}: QuestionCardProps) => {
  return (
    <div
      className={`transition-all duration-300 transform ${isVisible 
        ? 'opacity-100 translate-x-0' 
        : direction === 'next' 
          ? 'opacity-0 -translate-x-8' 
          : 'opacity-0 translate-x-8'
      }`}
    >
      <Card className="shadow-soft hover:shadow-elevated transition-shadow duration-300">
        <CardContent className="p-6 sm:p-8">
          <div className="mb-6">
            <h2 className="text-xl sm:text-2xl font-semibold text-brand-blue">
              {question.text}
            </h2>
            
            {question.malayalamText && (
              <p className="mt-2 text-md sm:text-lg text-gray-700 font-medium">
                {question.malayalamText}
              </p>
            )}
          </div>
          
          <div className="space-y-3">
            {question.options.map((option, index) => (
              <div
                key={index}
                className={`p-4 rounded-lg border-2 transition-all duration-200 cursor-pointer ${
                  selectedAnswer === option
                    ? 'border-brand-blue bg-brand-blue/5'
                    : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
                }`}
                onClick={() => onSelectOption(option)}
              >
                <div className="flex items-center">
                  <div 
                    className={`w-5 h-5 rounded-full border flex items-center justify-center mr-3 ${
                      selectedAnswer === option
                        ? 'border-brand-blue'
                        : 'border-gray-400'
                    }`}
                  >
                    {selectedAnswer === option && (
                      <div className="w-3 h-3 rounded-full bg-brand-blue" />
                    )}
                  </div>
                  <span className={selectedAnswer === option ? 'font-medium' : ''}>
                    {option}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default QuestionCard;
